// Libraries
import _ from 'lodash';
import React from 'react';

// Supermove
import {Form} from '@supermove/components';
import {gql} from '@supermove/graphql';
import {OrganizationModel, UserModel} from '@supermove/models';

// App
import FieldInput from '@shared/design/components/Field/FieldInput';
import MultiDropdownCheckboxInput from '@shared/design/components/Field/MultiDropdownCheckboxInput';
import UserRole from '@shared/modules/User/enums/UserRole';

const getRelatedOrganizationsOfficeStaffWithActiveAccountGrantOptions = ({
  organization,
  noneOptionLabel,
}: {
  organization: OrganizationModel;
  noneOptionLabel: string;
}) => {
  const relatedOrganizationsOfficeStaffOptions = _.flatten(
    organization.salesStaffOrganizations.map((organization: any) => {
      return organization.salespersons
        .filter((user: UserModel) => user.primaryCalendar)
        .map((user: UserModel) => {
          return {
            value: _.toNumber(user.id),
            label: user.fullName,
            description: organization.name,
          };
        });
    }),
  );

  const sortedOrgs: {
    value: number | null;
    label: string;
    description: string;
  }[] = _.sortBy(relatedOrganizationsOfficeStaffOptions, ['label']);
  if (noneOptionLabel) {
    sortedOrgs.unshift({value: null, label: noneOptionLabel, description: 'All branches'});
  }
  return sortedOrgs;
};

const OrganizationSalesPersonWithCalendarSelect = ({
  organization,
  form,
}: {
  organization: OrganizationModel;
  form: Form;
}) => {
  const salespersonOptions = getRelatedOrganizationsOfficeStaffWithActiveAccountGrantOptions({
    organization,
    noneOptionLabel: 'All branches',
  });

  return (
    <FieldInput
      {...form}
      index={0}
      label={'Sales Calendar'}
      name={'calendarUsersForm.userIds'}
      component={MultiDropdownCheckboxInput}
      input={{
        options: salespersonOptions,
        setFieldValue: form.setFieldValue,
        isResponsive: true,
        isPortaled: true,
        placeholder: `Select calendar(s)`,
        usePills: true,
      }}
    />
  );
};

OrganizationSalesPersonWithCalendarSelect.fragment = gql`
  fragment OrganizationSalesPersonWithCalendarSelect on Organization {
    id
    salesStaffOrganizations {
      id
      name
      salespersons: filteredUsersV2(roles: [${UserRole.getGraphqlArgs([...UserRole.OFFICE_ROLES])}]) {
        id
        fullName
        email
        primaryCalendar {
          id
        }
      }
    }
  }
`;

export default OrganizationSalesPersonWithCalendarSelect;
